export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19')
];

export const server_loads = [];

export const dictionary = {
		"/": [~2],
		"/blog": [3],
		"/blog/[blogTitle]": [~4],
		"/contact": [5],
		"/creators": [6],
		"/curated-tasmania-experiences": [7],
		"/custom-private-tours": [8],
		"/faq": [9],
		"/legal": [10],
		"/private-tours": [11],
		"/southeast-asia": [12],
		"/student-tasmania": [13],
		"/tasmanian-golf-experiences": [14],
		"/tour-guide-academy": [15],
		"/tours": [~16],
		"/tours/coal-river-wine-hopper": [18],
		"/tours/legends-of-tasmania-golf-history-and-flavour-4-days-4-nights": [19],
		"/tours/[tourName]": [~17]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.js';